// src/redux/slices/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Initial state for the cart
const initialState = {
  items: [], // Each item could include: id, productName, price, quantity, etc.
  shippingFee: 4.00, // Default shipping fee (can be dynamic as needed)
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Add an item to the cart. If the item exists, increase its quantity.
    addItem: (state, action) => {
      const newItem = action.payload;
      const existingItem = state.items.find(item => item.id === newItem.id);
      if (existingItem) {
        existingItem.quantity += newItem.quantity;
      } else {
        state.items.push(newItem);
      }
    },
    // Remove an item from the cart by its id
    removeItem: (state, action) => {
      const idToRemove = action.payload;
      state.items = state.items.filter(item => item.id !== idToRemove);
    },
    // Update the quantity of an item in the cart
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find(item => item.id === id);
      if (item) {
        item.quantity = quantity;
      }
    },
    // Clear the entire cart
    clearCart: (state) => {
      state.items = [];
    },
  },
});

// Export actions to dispatch them from components
export const { addItem, removeItem, updateQuantity, clearCart } = cartSlice.actions;

// Export the reducer to add to your store
export default cartSlice.reducer;
